import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  '2024-guochanshouji-zipaizhaoxiang-paihangbang': 'https://readdy.ai/api/search-image?query=Top%20view%20of%20modern%20Chinese%20smartphone%20with%20camera%20lens%20visible%2C%20minimalist%20warm%20desk%20setup%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20professional%20product%20photography%2C%20elegant%20composition%20with%20terracotta%20accents&width=600&height=400&seq=phone-ranking-hero&orientation=landscape',
  'zizai-goutu-sanfenfa-jiqiao': 'https://readdy.ai/api/search-image?query=Smartphone%20showing%20camera%20grid%20lines%20for%20photography%20composition%2C%20warm%20studio%20setting%20with%20natural%20light%2C%20minimalist%20flat%20lay%2C%20cream%20background%2C%20artistic%20photography%20tutorial%20aesthetic&width=600&height=400&seq=composition-rule-of-thirds&orientation=landscape',
  'ziran-guang-zhuajian-zimei': 'https://readdy.ai/api/search-image?query=Beautiful%20natural%20window%20light%20streaming%20into%20minimalist%20room%2C%20smartphone%20on%20tripod%2C%20warm%20golden%20sunlight%2C%20soft%20shadows%2C%20cream%20walls%2C%20cozy%20photography%20studio%20atmosphere&width=600&height=400&seq=natural-light-selfie&orientation=landscape',
};

const categoryNames: Record<string, string> = {
  'shebei-xuangou': '设备选购',
  'goutu-jiqiao': '构图技巧',
  'buguang-dengguang': '布光与灯光',
  'houqi-xiutu': '后期修图',
  'paizhe-changjing': '拍摄场景',
  'zimei-jingyan': '自媒经验',
};

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              精选教程推荐
            </h2>
            <p className="text-foreground-600 text-sm">
              最受欢迎的国产自拍深度教程，帮你快速提升拍照水平
            </p>
          </div>
          <Link
            to="/category/goutu-jiqiao"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={articleImages[article.slug] || articleImages['2024-guochanshouji-zipaizhaoxiang-paihangbang']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-primary-700">
                  {categoryNames[article.category] || article.category}
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span>{article.readTime}</span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-1.5 mt-4">
                  {article.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs font-medium"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/goutu-jiqiao"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
          >
            查看全部教程
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}